import React, { useState, useEffect } from "react";
import RequestsTable from "./components/RequestsTable";
import Filter from "./modals/Filter";
import Divider from "@material-ui/core/Divider";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import axios from "axios";
import { v4 as uuid } from "uuid";
import { updateObject } from "../../../helpers/updateObject";

export default function Requests() {
  const [showFilter, setShowFilter] = React.useState(false);

  function handleChange() {
    setShowFilter((key) => !key);
  }


  const [error, setError] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [sortField, setSortField] = useState("id");
  const [orderBy, setOrderBy] = useState(false);
  const [rows, setRows] = useState([]);
  const [skip, setSkip] = useState(0);
  const [take, setTake] = useState(10);
  const [count, setCount] = useState(0);
  const [filter, setFilter] = useState(false);
  const [filterInputs, setFilterInputs] = useState({
    employeeFullName: "",
    assetId: "",
    text: "",
    requestDate: "",
  });

  const [assets, setAssets] = useState([]);

  const onWishLists = (skip, take, sortField, orderBy) => {
    setIsLoaded(true);
    axios
      .get(
        `${process.env.REACT_APP_API_URL}wishList?Skip=${skip}&Take=${take}&SortField=${sortField}&OrderBy=${orderBy}`,
        {
          headers: {
            "Accept-Language": 1,
          },
        }
      )
      .then(
        ({ data: { data, totalCount } }) => {
          setIsLoaded(false);
          setRows(data);
          setCount(totalCount);
          setError(false);
        },
        (error) => {
          setIsLoaded(false);
          setError(true);
          setRows([]);
          setCount(0);
        }
      );
  };
  const onFilter = (skip, take, sortField, orderBy, filterInputs) => {
    setIsLoaded(true);
    const { employeeFullName, assetId, text, requestDate } = filterInputs;
    axios
      .get(
        `${process.env.REACT_APP_API_URL}wishList/filter?Skip=${skip}&Take=${take}&SortField=${sortField}&OrderBy=${orderBy}&EmployeeFullName=${employeeFullName}&AssetId=${assetId}&Text=${text}&RequestDate=${requestDate}`,
        {
          headers: {
            "Accept-Language": 1,
          },
        }
      )
      .then(
        ({ data: { data, totalCount } }) => {
          setIsLoaded(false);
          setRows(data);
          setCount(totalCount);
          setError(false);
        }
        ).catch((error) => {
          setIsLoaded(false);
          setError(true);
          setRows([]);
          setCount(0);
        });
  };


  const onUpdateWishListStatus = (id, statusType) => {
    let status = !statusType;
    axios
      .put(
        `${process.env.REACT_APP_API_URL}wishList/updateStatus`,
        {
          id,
          status,
        },
        {
          headers: {
            "x-requestid": uuid(),
          },
        }
      )
      .then(() => {
        onWishLists(skip, take, sortField, orderBy);
      });
  };

  const filterInputsUpdate = (e) => {
    const updateFiltersInput = updateObject(filterInputs, {
      [e.target.name]: e.target.value,
    });

    setFilterInputs(updateFiltersInput);
    setSkip(0);
    setFilter(true);
  };

  const onAssets = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}asset`, {
        headers: {
          "Accept-Language": 1,
        },
      })
      .then(({ data: { data } }) => {
        setAssets(data);
      });
  };

  const filterInputsUpdateSelect = (key, value) => {
    const updateFiltersInput = updateObject(filterInputs, {
      [key]: value,
    });

    setFilterInputs(updateFiltersInput);
    setSkip(0);
    setFilter(true);
  };

  useEffect(() => {
    onAssets();
  }, []);

  useEffect(() => {
    if (filter) {
      const timer = setTimeout(() => {
        onFilter(skip, take, sortField, orderBy, filterInputs);
      }, 500);

      return () => clearTimeout(timer);
    } else {
      onWishLists(skip, take, sortField, orderBy);
    }
  }, [skip, take, sortField, orderBy, filter, filterInputs]);


  const onWishListsExport = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}wishList/export`, {
        responseType: "blob",
      })
      .then((res) => {
        var url = window.URL.createObjectURL(new Blob([res.data]));
        var a = document.createElement("a");
        a.href = url;
        a.download = "WishLists.xlsx";
        document.body.appendChild(a);
        a.click();
        a.remove();
      });
  };

  return (
    <div className="row bg-white rounded">
      <div className="col-12 d-flex align-items-center py-4  fixed-title">
        <h1 className="display-4 mb-0">Requests by Employee</h1>
        <FormControlLabel
          control={
            <Switch
              checked={showFilter}
              onChange={handleChange}
              color="secondary"
            />
          }
          label={showFilter ? "Hide filter" : "Show filter"}
          className="ml-auto mb-0"
        />
      </div>
      <Divider className="w-100" />
      <RequestsTable
        setSortField={setSortField}
        setOrderByTable={setOrderBy}
        sortField={sortField}
        orderBy={orderBy}
        isLoaded={isLoaded}
        error={error}
        rows={rows}
        updateSkip={setSkip}
        updateTake={setTake}
        count={count}
        onUpdateWishListStatus={onUpdateWishListStatus}
        onWishListsExport={onWishListsExport}
      />
      <Filter
        show={showFilter}
        onHide={handleChange}
        filterInputsUpdate={filterInputsUpdate}
        filterInputsUpdateSelect={filterInputsUpdateSelect}
        filterInputs={filterInputs}
        assets={assets}
      />
    </div>
  );
}
